
let configs = {
  bipAppId() {
    // return '47b1181148da4063b5ef17759dcaee25'
    return localStorage.getItem('appId')
  },
  goPageUrl() {
    let url = location.origin + location.pathname + location.search + '#'
    return url
  },
  goPageData(goPageUrl) {
    TgaBridge.goPage(JSON.stringify(goPageUrl), (res) => {
      console.log('res++++++++++++goPage', res)
    })
  },
  adTest() {
    return 1
  },

  guolv() {
    var id = ['8618559862236', '8618259064163', '8618020999659', '8618650749068']
    var msisdn = localStorage.getItem('msisdn')
    return id.includes(msisdn)
  },


  // 获取是否是当前的什么字段
  getTheme() {
    var theme = localStorage.getItem('biptheme')
    switch (theme) {
      case 'dark-blue':
        return 'khalaspay'
        break;
      case 'candlelight':
        return 'candlelight'
        break;
      case 'dark':
        return 'dark'
        break;
      case 'lavender':
        return 'lavender'
        break;
      case 'orange':
        return 'orange'
        break;
      case 'night-blue':
        return 'night-blue'
        break;
      default:
        return 'regular'
        break;
    }
  },


  // 获取localStorage
  getStorage(data) {
    if (localStorage.getItem(data)) {
      return JSON.parse(localStorage.getItem(data))
    } else {
      return ''
    }

  },
  setStorage(key, data) {
    return JSON.stringify(localStorage.setItem(key, data))
  },
  NewDate(data) {
    var d = new Date(data)
    var year = d.getFullYear() //年
    var month = d.getMonth() + 1 //月
    var day = d.getDate() //日
    var hh = d.getHours() //时
    var mm = d.getMinutes() //分
    var ss = d.getSeconds() //秒
    var clock = year + '.'
    if (month < 10) clock += '0'
    clock += month + '.'
    if (day < 10) clock += '0'
    clock += day

    return clock
  },
  NewData(data) {
    var d = new Date(data)
    var year = d.getFullYear() //年
    var month = d.getMonth() + 1 //月
    var day = d.getDate() //日
    var hh = d.getHours() //时
    var mm = d.getMinutes() //分
    var ss = d.getSeconds() //秒
    var clock = year + '/'
    if (month < 10) clock += '0'
    clock += month + '/'
    if (day < 10) clock += '0'
    clock += day + ' '
    if (hh < 10) clock += '0'
    clock += hh + ':'
    if (mm < 10) clock += '0'
    clock += mm + ':'
    if (ss < 10) clock += '0'
    clock += ss
    return clock
  },
  GetQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
    var context = "";
    if (r != null) context = r[2];
    reg = null;
    r = null;

    return context == null || context == "" || context == "undefined"
      ? ""
      : context;
  },

  formateNumber(num) {
    var num = (num || 0).toString(), result = '';
    while (num.length > 3) {
      result = ',' + num.slice(-3) + result;
      num = num.slice(0, num.length - 3);
    }
    if (num) { result = num + result }
    return result
  }
}



export default configs



// WEBPACK FOOTER //
// ./src/config/config.js